export default __webpack_public_path__ + "static/media/UGC1.90ec2a15.gif";